import Image from 'next/image'
import maxWeigelLogo from './maxweigel.png'

type IconProps = {
  className?: string
}

const MaxWeigelLogo: React.FC<IconProps> = ({ ...attributes }) => {
  return <Image src={maxWeigelLogo} alt="Max Weigel Logo" height={48} {...attributes} />
}

export default MaxWeigelLogo
